import { cn } from '@/lib/utils';
import { Database, MessageSquare, MousePointer2 } from 'lucide-react';

import {
    Tooltip,
    TooltipContent,
    TooltipTrigger
} from '@/components/ui/tooltip';

import { TOOLBAR_TOOLTIP } from './toolbarTooltip';

export type DashboardMode = 'use' | 'sources' | 'comment';

const MODES = [
    {
        mode: 'use',
        label: 'Use the page',
        tooltip: 'Use the page',
        icon: <MousePointer2 className="w-4 h-4" />
    },
    {
        mode: 'sources',
        label: 'See where the numbers come from',
        tooltip: 'See where the data comes from',
        icon: <Database className="w-4 h-4" />
    },
    {
        mode: 'comment',
        label: 'Comment on an element',
        tooltip: 'Comment',
        icon: <MessageSquare className="w-4 h-4" />
    }
] as const;

interface DashboardModeToggleProps {
    mode: DashboardMode;
    canComment: boolean;
    onChange: (mode: DashboardMode) => void;
}

export function DashboardModeToggle({
    mode,
    canComment,
    onChange
}: DashboardModeToggleProps) {
    return (
        <div
            role="group"
            aria-label="View"
            className="flex gap-0.5 bg-muted p-[3px] rounded-[11px]"
        >
            {MODES.filter(
                (option) => canComment || option.mode !== 'comment'
            ).map((option) => (
                <Tooltip key={option.mode}>
                    <TooltipTrigger asChild>
                        <button
                            type="button"
                            onClick={() => onChange(option.mode)}
                            aria-label={option.label}
                            aria-pressed={mode === option.mode}
                            className={cn(
                                'flex justify-center items-center rounded-lg w-9 h-7 transition-colors',
                                mode === option.mode
                                    ? 'bg-background text-foreground shadow-xs'
                                    : 'text-muted-foreground hover:text-foreground'
                            )}
                        >
                            {option.icon}
                        </button>
                    </TooltipTrigger>
                    <TooltipContent {...TOOLBAR_TOOLTIP}>
                        {option.tooltip}
                    </TooltipContent>
                </Tooltip>
            ))}
        </div>
    );
}
